var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14.25C10.9518 14.25 13.75 11.4518 13.75 8C13.75 4.54822 10.9518 1.75 7.5 1.75C4.04822 1.75 1.25 4.54822 1.25 8C1.25 11.4518 4.04822 14.25 7.5 14.25ZM7.5 7.375C7.84518 7.375 8.125 7.65482 8.125 8V10.5C8.125 10.8452 7.84518 11.125 7.5 11.125C7.15482 11.125 6.875 10.8452 6.875 10.5V8C6.875 7.65482 7.15482 7.375 7.5 7.375ZM7.5 4.875C7.15482 4.875 6.875 5.15482 6.875 5.5C6.875 5.84518 7.15482 6.125 7.5 6.125H7.50708C7.85226 6.125 8.13208 5.84518 8.13208 5.5C8.13208 5.15482 7.85226 4.875 7.50708 4.875H7.5Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e9cc0e6a1bf224ab43e751db8cb35c36.svg";
export { ForwardRef as ReactComponent };